import { Helmet } from 'react-helmet-async';

import { stripHtmlTags } from '@change-corgi/core/html';

import { usePageMeta } from './usePageMeta';

export function PageMeta() {
	const {
		data: { objective, description },
	} = usePageMeta();

	return (
		<Helmet>
			<title>{`${objective} · Movement`}</title>
			<meta name="description" content={stripHtmlTags(description)} />
		</Helmet>
	);
}
